import { render, staticRenderFns } from "./DialogInner.vue?vue&type=template&id=6542059a&"
import script from "./DialogInner.vue?vue&type=script&lang=js&"
export * from "./DialogInner.vue?vue&type=script&lang=js&"
import style0 from "./DialogInner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports